<div class="row">
  <div class="col-md-6">
    <form class="form-horizontal" #gpsDataEntry="ngForm">
      <div class="card card-body">
        <div class="form-group row">
          <app-material-pg-input
            label="شماره دستگاه ردیاب"
            type="text"
            name="imei"
            id="imei"
            maxlength="15"
            minlength="8"
            [(ngModel)]="selectedTracker.imei"
            [disabled]="edit"
            tabindex="1"
            [required]=true>
          </app-material-pg-input>
        </div>
        <div class="form-group row">
          <app-material-pg-input
            label="شماره همراه ردیاب "
            type="text"
            name="mobileNumber"
            id="mobileNumber"
            maxlength="11"
            minlength="11"
            [(ngModel)]="selectedTracker.mobileNumber"
            tabindex="2"
            [required]=true>
          </app-material-pg-input>
        </div>
        <div class="form-group row">
              <app-material-auto-complete
                name="trackerType"
                id="trackerType"
                [placeholder]="'نوع ردیاب'"
                [formatter]="trackerTypeFormatter"
                [items]="trackerTypes"
                [(ngModel)]="selectedTracker.trackerType"
                tabindex="3"
                [required]=true>
              </app-material-auto-complete>
        </div>
        <div class="form-group row">
          <div>
            <button
              mat-raised-button
              mat-stroked-button
              type="submit"
              class="pull-right "
              [disabled]="!gpsDataEntry.form.valid"
              (click)="save()"
              tabindex="4">
              Save
            </button>
          </div>
        </div>
      </div>
      <div class="card card-body">
        <div class="col-md-12">
          <table
            class="table table-sm table-striped table-bordered">
            <thead>
              <tr>
                <th>شماره کشنده</th>
                <th>تاریخ شروع</th>
                <th>تاریخ پایان</th>
              </tr>
            </thead>
            <tbody>
              @for (object of history; track $index) {
                <tr>
                  <td>{{object.truckNumber}}</td>
                  <td>{{dateFormatter(object.startDate)}}</td>
                  <td>{{dateFormatter(object.endDate)}}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </form>
  </div>
</div>